module.exports = __webpack_public_path__ + "static/media/Portfolio_preview.6de02398.jpg";